import { render, staticRenderFns } from "./PlanDataList.vue?vue&type=template&id=326a6b1c&lang=pug"
import script from "./PlanDataList.vue?vue&type=script&lang=js"
export * from "./PlanDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326a6b1c')) {
      api.createRecord('326a6b1c', component.options)
    } else {
      api.reload('326a6b1c', component.options)
    }
    module.hot.accept("./PlanDataList.vue?vue&type=template&id=326a6b1c&lang=pug", function () {
      api.rerender('326a6b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/PlanDataList.vue"
export default component.exports